import { CommonModule } from '@angular/common';
import { Component, NgModule, ChangeDetectorRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxCheckBoxModule } from 'devextreme-angular';
import { DxButtonModule } from 'devextreme-angular';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { AuthService } from '../../services';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent {
  loading = false;
  formData: any = {};
  passwordVisible = false;
  eyeIcon = 'eyeopen';

  passwordEditorOptions = {
    stylingMode: 'filled',
    mode: 'password',
    buttons: [
      { name: 'lock', location: 'before', options: { icon: 'lock' } },
      { 
        name: 'toggleVisibility', 
        location: 'after', 
        options: { 
          icon: 'eyeopen',
          stylingMode: 'text',
          onClick: () => this.togglePasswordVisibility()
        }
      }
    ]
  };

  constructor(
    private authService: AuthService, 
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  async onSubmit(e: Event) {
    e.preventDefault();
    const { email, password } = this.formData;
    this.loading = true;

    const result = await this.authService.logIn(email, password);
    if (!result.isOk) {
      this.loading = false;
      notify(result.message, 'error', 2000);
    }
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
    this.eyeIcon = this.passwordVisible ? 'eyeclose' : 'eyeopen';

    this.passwordEditorOptions = {
      ...this.passwordEditorOptions,
      mode: this.passwordVisible ? 'text' : 'password',
      buttons: [
        { name: 'lock', location: 'before', options: { icon: 'lock' } },
        { 
          name: 'toggleVisibility', 
          location: 'after', 
          options: { 
            icon: this.eyeIcon, 
            stylingMode: 'text',
            onClick: () => this.togglePasswordVisibility()
          }
        }
      ]
    };

    this.cdr.detectChanges();
  }
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxCheckBoxModule,
    DxButtonModule
  ],
  declarations: [ LoginFormComponent ],
  exports: [ LoginFormComponent ]
})
export class LoginFormModule { }